import { Collapse } from "@mui/material";
import React from "react";
import { useCreatorThemeContext } from "../../../../../features/Common/modules/Theme/CreatorThemeContext";
import { classNames } from "../../../../../utils/common/styling";
import Button from "../../../../common/Button/Button";
import Comment from "../Comment/Comment";
import { HighlightedCommentWrapper } from "../CommentSection/modules/HighlightedCommentWrapper/HighlightedCommentWrapper";
import { getThemedStyles, styles } from "./Replies.styles";
import { IRepliesProps } from "./Replies.types";

const Replies = ({
  show,
  data,
  userUuid,
  userImgSrc,
  isCreator,
  creatorUuid,
  loggedInUserFullName,
  userAvatarPreference,
  cdnBaseUrl,
  fetchCdnAsset,
  enableHideUnhideComment,
  showHighlightedReply,
  highlightedReply,
  onReplyLikeClick,
  callGetReplyLikedByMembersListApi,
  onReplyUpdate,
  onReplyDelete,
  showLoadMoreRepliesBtn,
  loadReplies,
  onReplyCtaClick,
  onMemberClick,
  CommentEditor,
  canReport,
  onReport,
  showReported,
}: IRepliesProps) => {
  const theme = useCreatorThemeContext();
  const themedStyles = getThemedStyles({ theme });

  const commentsCommonProps = {
    userUuid: userUuid,
    userImgSrc: userImgSrc,
    isCreator: isCreator,
    creatorUuid: creatorUuid,
    cdnBaseUrl: cdnBaseUrl,
    fetchCdnAsset,
    enableHideUnhideComment: enableHideUnhideComment,
    loggedInUserFullName: loggedInUserFullName,
    userAvatarPreference: userAvatarPreference,
    CommentEditor: CommentEditor,
    onUpdate: onReplyUpdate,
    onDelete: onReplyDelete,
    callGetLikedByMembersListApi: callGetReplyLikedByMembersListApi,
    onLikeClick: onReplyLikeClick,
    onReplyCtaClick: onReplyCtaClick,
    onMemberClick: onMemberClick,
    canReport,
    onReport,
    showReported,
  };

  return show ? (
    <>
      <Collapse
        in={!!data.length}
        classes={{ wrapperInner: styles.repliesContainer }}
      >
        {showHighlightedReply && highlightedReply && (
          <Comment
            key={highlightedReply.uuid}
            data={highlightedReply}
            CommentWrapper={HighlightedCommentWrapper}
            {...commentsCommonProps}
          />
        )}

        {(showHighlightedReply
          ? data.filter((reply) => reply.uuid != highlightedReply?.uuid)
          : data
        ).map((i) => (
          <Comment key={i.uuid} data={i} {...commentsCommonProps} />
        ))}
      </Collapse>
      {showLoadMoreRepliesBtn ? (
        <Button
          className={classNames(
            styles.loadMoreRepliesBtn,
            themedStyles.loadMoreRepliesBtn,
          )}
          onClick={loadReplies}
          color="unset"
          size="unset"
        >
          Load more replies
        </Button>
      ) : null}
    </>
  ) : null;
};

export default Replies;
